/**
 * Application Entry Point
 *
 * This is the main entry point for the FunnelHub application.
 * It sets up:
 * - React root rendering
 * - Internationalization (i18n)
 * - Web vitals reporting
 * - Global styles
 *
 * The application is mounted to the DOM element with id 'root'.
 */

import React from "react";
import ReactDOM from "react-dom/client";
// import "bootstrap/dist/css/bootstrap.css"; // Using custom Bootstrap via SCSS instead
import "./custom.scss"; // Custom SCSS with Bootstrap overrides
import "./index.css"; // Global CSS styles
import App from "./App"; // Main application component
import "./i18n.js"; // Internationalization setup
import reportWebVitals from "./reportWebVitals"; // Performance monitoring
/**
 * Create React root and render the application
 * Using the new React 18 createRoot API for concurrent features
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

/**
 * Web Vitals Reporting
 *
 * Measures and reports Core Web Vitals and other performance metrics
 * Can be configured to send data to analytics by providing a function
 *
 * @see https://bit.ly/CRA-vitals
 */
reportWebVitals();
